const HERO_IMG = "/api/uploads/wfkl70dr_group_shot.webp";

export default function RugbyHeroBanner() {
  return (
    <div
      data-testid="rugby-hero-banner"
      className="relative w-full aspect-[16/6] sm:aspect-[16/5] mb-8 overflow-hidden bg-[#0A0A0A] border border-[#262626]"
    >
      <img
        src={HERO_IMG}
        alt="Untamed Gear rugby team group shot on the field"
        loading="eager"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/40 to-transparent" />
      <div className="relative z-10 h-full flex flex-col justify-end sm:justify-center p-5 sm:p-10 max-w-2xl">
        <p className="text-[#F7931E] text-xs sm:text-sm font-bold uppercase tracking-[0.3em] mb-2 font-heading">
          Rugby Gear
        </p>
        <h2
          data-testid="rugby-hero-tagline"
          className="text-white text-2xl sm:text-4xl lg:text-5xl font-black uppercase tracking-tighter leading-[0.95] font-heading"
        >
          Play Loud. Play Untamed.
        </h2>
      </div>
    </div>
  );
}
